import React from "react";
import { Table, Input, Button, Space, Image, Typography } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import StockVariation from "./StockVariation";
import Quickview from "./Quickview";
const { Text } = Typography;
var formatter = new Intl.NumberFormat("en-IN");

class Rendertable extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
    totalPage: this.props.List.count,
    current: this.props.pageno.current,
    minIndex: 0,
    maxIndex: 0,
    stockVariationVisible: false,
    selectedVariation: null,
  };

  onSelectChange = (selectedRowKeys) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  // Handle opening StockVariation drawer
  handleStockVariationOpen = (details) => {
    this.setState({
      stockVariationVisible: true,
      selectedVariation: details,
    });
  };

  // Handle closing StockVariation drawer
  handleStockVariationClose = () => {
    this.setState({
      stockVariationVisible: false,
      selectedVariation: null,
    });
  };

  // Handle success callback from StockVariation
  handleStockVariationSuccess = () => {
    // Reload the table data
    this.props.setreload(!this.props.reload);
    this.props.setloading(true);
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8, marginTop: -140 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleChange = (page, page_size) => {
    if (isNaN(page_size) || page_size == undefined) {
      page = 1;
      page_size = this.props.List.count;
    }
    this.props.pageno.current = page;
    this.props.page_size.current = page_size;
    this.props.setreload(!this.props.reload);
    this.props.setloading(true);
    this.setState({
      current: page,
      minIndex: (page - 1) * this.props.page_size.current,
      maxIndex: page * this.props.page_size.current,
    });
  };

  render() {
    const { REACT_APP_API_URL } = process.env;
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const columns = [
      {
        title: "SL",
        key: "index",
        width: "5%",
        render: (value, item, index) => {
          return this.state.current > 1
            ? this.state.current * 10 + index + 1
            : index + 1;
        },
      },
      {
        title: "Barcode",
        dataIndex: "barcode",
        key: "barcode",
        width: "12%",
        ...this.getColumnSearchProps("barcode"),
      },
      {
        title: "Product Name",
        dataIndex: "product_code",
        key: "product_code",
        ...this.getColumnSearchProps("product_code"),
      },
      {
        title: "Batch No",
        align: "batch_no",
        dataIndex: "batch_no",
        key: "batch_no",
      },
      {
        title: "Category",
        dataIndex: "category",
        key: "category",
        ...this.getColumnSearchProps("category"),
      },
      {
        title: "Variation",
        dataIndex: "Attribute_details",
        align: "center",
        key: "Attribute_details",
        ...this.getColumnSearchProps("Attribute_details"),
      },
      {
        title: "Quantity",
        align: "right",
        dataIndex: "quantity",
        key: "quantity",
      },
      {
        title: "Selling Price",
        align: "right",
        dataIndex: "selling_price",
        key: "selling_price",
      },
      {
        title: "Location",
        align: "right",
        dataIndex: "Warehouse_name",
        key: "Warehouse_name",
        ...this.getColumnSearchProps("Warehouse_name"),
      },
      {
        title: "Action",
        dataIndex: "",
        key: "x",
        render: (details) => {
          return (
            <Space>
              <Quickview details={details} />
              <Button
                type="primary"
                size="middle"
                onClick={() => this.handleStockVariationOpen(details)}
              >
                Edit
              </Button>
            </Space>
          );
        },
      },
    ];
    let page_sizes = [5, 10, 20, 50, 100];
    let page_size_opt = [];
    for (let i = 0; i < page_sizes.length; i++) {
      if (page_sizes[i] < this.props.List.count)
        page_size_opt.push(page_sizes[i]);
    }
    page_size_opt.push(this.props.List.count);
    return (
      <>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={this.props.List.results}
          size="small"
          pagination={{
            defaultPageSize: this.props.page_size.current,
            current: this.state.current,
            total: this.props.List.count,
            pageSizeOptions: page_size_opt,
            showSizeChanger: true,
            onChange: this.handleChange,
          }}
          summary={(pageData) => {
            let total_data = this.props.total_data.current;
            return (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell colSpan={6}>
                    <b>Total</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell className="ant_right">
                    <Text>
                      <b>{formatter.format(total_data["total_quantity"])}</b>
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell className="ant_right">
                    <Text>
                      <b>{formatter.format(total_data["total_selling_price"])}</b>
                    </Text>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell colSpan={2}></Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            );
          }}
        />
        <StockVariation
          visible={this.state.stockVariationVisible}
          onClose={this.handleStockVariationClose}
          details={this.state.selectedVariation}
          onSuccess={this.handleStockVariationSuccess}
        />
      </>
    );
  }
}

export default Rendertable;